import {Card, Container, styled} from '@mui/material';

export const StyledCard = styled(Card)`
	max-width: 852px;
	padding: 16px;
	display: flex;
	flex-direction: column;
	justify-items: center;
	gap: 16px;
	margin: 0 auto;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 24px;
		flex-direction: row;
	}
`;

export const StyledContainer = styled(Container)`
	padding: 0px;
	margin-bottom: 56px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 32px;
	}
`;

export const StyledImage = styled('div')`
	width: 360px;
	height: 394px;
	display: none;

	${({theme}) => theme.breakpoints.up('sm')} {
		display: block;
	}
`;

export const StyledLabel = styled('label')`
	color: ${({theme}) => theme.palette.text.primary};
	font-weight: 600;
`;
